import { NIL } from "uuid";

import { LoadResponse } from "../../models/api/load";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentSTO } from "../../models/documents/document-sto";
import { DocumentsReportDTO } from "../../models/documents/documents-reports";
import { DocumentsReportFilter } from "../../models/documents/documents-reports/documents-report.filter";
import { PeriodType } from "../../models/documents/period";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class DocumentsReportsApiService extends BaseApiService<DocumentsReportDTO, DocumentSTO> {
  constructor() {
    super({
      servicePath: "/DocumentsReports",
      loadItemsPath: "/GetDocumentsReport",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadDocumentsReports = async (
  searchOptions: { query: string; exactMatch: boolean },
  reportId: string = NIL,
  year: number = new Date().getFullYear(),
  allReportFiles = false,
  legalEntityIds: string[] = [], // to exclude getting everything
  withoutLegalEntity = false,
  periodTypes: PeriodType[] = [],
  loadItemsPath: "/GetDocumentsReport" | "/GetInvoicesTrackingReport" | "/GetEmployeeGroupDocumentsReport",
  signal?: AbortSignal
): Promise<LoadResponse<DocumentsReportDTO>> => {
  const documentsReportsApiService = new DocumentsReportsApiService();
  if (loadItemsPath) documentsReportsApiService.useLoadItemsPath(loadItemsPath);

  const response = await documentsReportsApiService.loadItems(
    {
      reportId,
      year,
      allReportFiles,
      legalEntityIds,
      withoutLegalEntity,
      periodTypes,
    } as DocumentsReportFilter,
    searchOptions.query,
    undefined,
    { pageNumber: 0, pageSize: 10000 },
    searchOptions.exactMatch,
    60,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};
